import { Progress } from "@/components/ui/progress";

// Verified-steps progress, mirroring the assessment QuestionHeader pattern.
export function LabProgress({
  percentage,
  label,
  verified,
  total,
}: {
  percentage: number;
  label: string;
  verified: number;
  total: number;
}) {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between gap-4">
        <span className="text-sm font-medium">{label}</span>
        <span className="text-sm text-muted-foreground">
          {verified} / {total} verified
        </span>
      </div>
      <Progress value={percentage} className="h-2" />
    </div>
  );
}
